@if (dispatchCampaign(); as dispatchCampaign) {
    <div class="dispatch-campaign-container">
        @if (dispatchCampaign.status != 'DISPATCHED') {
            <section
                class="sticky top-0 z-20 flex flex-wrap items-center gap-x-4 gap-y-2 px-4 py-2 border-b border-border! bg-surface/95 backdrop-blur">
                <div class="flex items-center gap-3 min-w-0">
                    <p-iconfield>
                        <p-inputicon class="ph ph-pen"></p-inputicon>
                        <input
                            type="text"
                            pInputText
                            pSize="small"
                            class="w-52"
                            placeholder="{{ 'NAME' | translate }}"
                            [(ngModel)]="dispatchCampaign.name"
                            (blur)="save()" />
                    </p-iconfield>
                    @if ((dispatchCampaign.status == 'READY_FOR_DISPATCH' && !dispatchCampaign.isArmed) || dispatchCampaign.isArmed) {
                        <p-tag
                            [severity]="dispatchCampaign.isArmed ? `success` : `warn`"
                            [pTooltip]="dispatchCampaign.isArmed ? (`CAMPAIGN_ARMED` | translate) : (`CAMPAIGN_NOT_ARMED` | translate)"
                            tooltipPosition="bottom"
                            [value]="
                                dispatchCampaign.isArmed ? (`CAMPAIGN_ARMED` | translate) : (`CAMPAIGN_NOT_ARMED` | translate)
                            "></p-tag>

                        
                    }

                    <div class="hidden xl:flex! gap-2 items-center!">
                        <p-tag severity="secondary">
                            <div class="flex! items-center justify-center gap-1">
                                <i class="ph ph-user"></i>
                                @if (dispatchCampaign.status == 'PROCESSING_TARGET_FILTER') {
                                    <span>{{ 'CALCULATING_AUDIENCE' | translate }}</span>
                                } @else {
                                    <span>{{ utils.numberFormat(dispatchCampaign.targetFilter?.preliminaryAudienceSize ?? 0) }}</span>
                                    <span class="lowercase!">{{ 'RECEIVERS' | translate }}</span>
                                }
                            </div>
                        </p-tag>

                        @if (dispatchCampaign.completedSteps?.HOW && dispatchCampaign.method?.primaryMethod; as primaryMethod) {
                            <p-tag severity="secondary">
                                <div class="flex! items-center justify-center gap-1">
                                    @if (primaryMethod == 'EMAIL') {
                                        <i class="ph ph-envelope-simple"></i>
                                    } @else if (primaryMethod == 'SMS') {
                                        <i class="ph ph-chat-circle"></i>
                                    }

                                    <span>{{ primaryMethod | translate }}</span>
                                    @if (dispatchCampaign.method?.secondaryMethod; as secondaryMethod) {
                                        <span>+ {{ secondaryMethod | translate }}</span>
                                    }
                                </div>
                            </p-tag>
                        }
                    </div>
                </div>

                <!-- Steps: click any step whose earlier steps are done. -->
                <nav class="flex items-center gap-1 mx-auto" [attr.aria-label]="'CAMPAIGN_STEPS' | translate">
                    @for (step of steps; track step; let i = $index) {
                        @let current = selectedStep() == step;
                        @let done = !!dispatchCampaign.completedSteps?.[step];
                        @if (i > 0) {
                            <span class="w-5 h-px" [class]="dispatchCampaign.completedSteps?.[steps[i - 1]] ? 'bg-success' : 'bg-border'"></span>
                        }
                        <button
                            type="button"
                            class="flex items-center gap-1.5 h-8 pl-1.5 pr-2.5 rounded-sm text-sm transition-colors disabled:cursor-not-allowed"
                            [class]="
                                current
                                    ? 'bg-concern-accent text-concern-accent-title font-medium'
                                    : done
                                      ? 'text-text hover:bg-surface-2'
                                      : 'text-text-muted hover:bg-surface-2 disabled:hover:bg-transparent'
                            "
                            [attr.aria-current]="current ? 'step' : null"
                            [disabled]="!canOpenStep(step)"
                            (click)="stepSelected(step)">
                            <span
                                class="size-5 rounded-full flex items-center justify-center text-[11px] font-semibold"
                                [class]="current ? 'bg-brand text-brand-ink' : done ? 'bg-success text-white' : 'bg-surface-sunk text-text-muted'">
                                @if (done && !current) {
                                    <i class="ph ph-check"></i>
                                } @else {
                                    {{ i + 1 }}
                                }
                            </span>
                            <span class="hidden md:inline">{{ step | translate }}</span>
                        </button>
                    }
                </nav>

                <!-- Step navigation lives up here so nothing covers the editor. -->
                <div class="flex items-center gap-2">
                    <button pButton size="small" [text]="true" severity="secondary" (click)="save()" [loading]="loading()">
                        <i class="ph ph-floppy-disk"></i>
                        <span>{{ `SAVE_DRAFT` | translate }}</span>
                    </button>
                    <span class="h-6 w-px bg-border"></span>
                    <button pButton size="small" [outlined]="true" severity="secondary" (click)="goBackToPrevStep()">
                        <i class="ph ph-arrow-left"></i>
                        <span>{{ `BACK` | translate }}</span>
                    </button>
                    @if (selectedStepValue() !== 4) {
                        <button
                            pButton
                            size="small"
                            (click)="panelSavetriggered($event)"
                            [disabled]="!validateStep()"
                            [loading]="loading()"
                            [pTooltip]="('NEXT_STEP' | translate) + ': ' + nextStep"
                            tooltipPosition="bottom">
                            <span>{{ `CONTINUE` | translate }}</span>
                            <span class="hidden lg:inline text-xs opacity-80">· {{ nextStep }}</span>
                            <i class="ph ph-arrow-right"></i>
                        </button>
                    } @else if (dispatchCampaign.status == 'PROCESSING_TARGET_FILTER') {
                        <button pButton size="small" (click)="saveWhen()" [disabled]="!validateStep()" [loading]="loading()">
                            <i class="ph ph-floppy-disk"></i>
                            <span>{{ `SAVE_CAMPAIGN` | translate }}</span>
                        </button>
                    } @else if (dispatchCampaign.isArmed) {
                        <!-- Only an armed campaign has a sendout to cancel. -->
                        <button pButton size="small" severity="danger" [outlined]="true" (click)="cancelDispatch($event)" [loading]="loading()">
                            <i class="ph ph-x-circle"></i>
                            <span>{{ `CANCEL_CAMPAIGN` | translate }}</span>
                        </button>
                    } @else {
                        <button pButton size="small" severity="success" (click)="confirmDispatch($event)" [disabled]="!validateStep()" [loading]="loading()">
                            <i class="ph ph-calendar-check"></i>
                            <span>{{ `SCHEDULE_CAMPAIGN` | translate }}</span>
                        </button>
                    }
                </div>
            </section>

            <p-stepper [value]="selectedStepValue()" [linear]="true" class="basis-160!" (valueChange)="selectedTabChanged($event)">

                <section class="flex flex-col justify-start items-center">
                    <p-step-panels class="pb-10">
                        <!-- #region WHO -->
                        <p-step-panel [value]="stepValueFromStep('WHO')">
                            <ng-template #content let-activateCallback="activateCallback">
                                <section class="flex flex-col justify-center items-center gap-4! px-4 max-w-3xl sm:px-6">
                                    <div class="text-center mb-6">
                                        <h2 class="text-text text-2xl font-semibold" translate>SELECT_TARGET_FILTER_MODE</h2>
                                        <p class="text-text-muted mt-1" translate>SELECT_TARGET_FILTER_MODE_SUBTITLE</p>
                                    </div>

                                    <div
                                        class="grid grid-cols-1 sm:grid-cols-2 gap-3 max-w-3xl mx-auto"
                                        (animate.enter)="animateStepIn($event)">
                                        <p-card
                                            class="group relative text-left rounded-xl border-2 transition-all duration-200 shadow-sm cursor-pointer"
                                            [ngClass]="
                                                dispatchCampaign.targetFilter?.mode === 'ALL_CUSTOMERS'
                                                    ? 'border-primary-600 bg-surface'
                                                    : 'border-border bg-surface hover:border-primary-300 hover:shadow-md'
                                            "
                                            (click)="selectTargetFilterMode('ALL_CUSTOMERS')">
                                            <div class="flex items-center gap-4!">
                                                <div class="flex! flex-col! justify-start items-start h-full">
                                                    <div
                                                        class="w-10 h-10 rounded-lg flex items-center justify-center shrink-0 transition-colors duration-200"
                                                        [ngClass]="
                                                            dispatchCampaign.targetFilter?.mode === 'ALL_CUSTOMERS'
                                                                ? 'bg-primary-600 text-text-on-brand!'
                                                                : 'bg-primary-50 text-primary-600'
                                                        ">
                                                        <i class="ph ph-users text-xl"></i>
                                                    </div>
                                                </div>

                                                <div class="min-w-0 flex-1">
                                                    <h3 class="font-semibold text-text text-sm">All customers</h3>
                                                    <p class="text-base text-text-muted mt-0.5 leading-relaxed">
                                                        {{ 'DISPATCH_CAMPAIGN_TARGET_MODE_ALL_CUSTOMERS_SUBTITLE' | translate }}
                                                    </p>
                                                </div>
                                                <i
                                                    class="ph ph-caret-right text-text-muted shrink-0 text-sm transition-transform duration-200 group-hover:translate-x-0.5"></i>
                                            </div>
                                        </p-card>

                                        <p-card
                                            class="group relative text-left rounded-xl border-2 transition-all duration-200 shadow-sm cursor-pointer"
                                            [ngClass]="
                                                dispatchCampaign.targetFilter?.mode === 'SPECIFIC_PACKAGES'
                                                    ? 'border-primary-600 bg-surface'
                                                    : 'border-border bg-surface hover:border-primary-300 hover:shadow-md'
                                            "
                                            (click)="selectTargetFilterMode('SPECIFIC_PACKAGES')">
                                            <div class="flex items-center gap-4!">
                                                <div
                                                    class="w-10 h-10 rounded-lg flex items-center justify-center shrink-0 transition-colors duration-200"
                                                    [ngClass]="
                                                        dispatchCampaign.targetFilter?.mode === 'SPECIFIC_PACKAGES'
                                                            ? 'bg-primary-600 text-text-on-brand'
                                                            : 'bg-primary-50 text-primary-600'
                                                    ">
                                                    <i class="ph ph-package text-xl"></i>
                                                </div>
                                                <div class="min-w-0 flex-1">
                                                    <h3 class="font-semibold text-text text-sm">
                                                        {{ 'DISPATCH_CAMPAIGN_TARGET_MODE_SPECIFIC_PACKAGES_TITLE' | translate }}
                                                    </h3>
                                                    <p class="text-base text-text-muted mt-0.5 leading-relaxed">
                                                        {{ 'DISPATCH_CAMPAIGN_TARGET_MODE_SPECIFIC_PACKAGES_SUBTITLE' | translate }}
                                                    </p>
                                                </div>
                                                <i
                                                    class="ph ph-caret-right text-text-muted shrink-0 text-sm transition-transform duration-200 group-hover:translate-x-0.5"></i>
                                            </div>
                                        </p-card>

                                        <p-card
                                            class="group relative text-left rounded-xl border-2 transition-all duration-200 shadow-sm cursor-pointer"
                                            [ngClass]="
                                                dispatchCampaign.targetFilter?.mode === 'NOT_BOOKED_SINCE'
                                                    ? 'border-primary-600 bg-surface'
                                                    : 'border-border bg-surface hover:border-primary-300 hover:shadow-md'
                                            "
                                            (click)="selectTargetFilterMode('NOT_BOOKED_SINCE')">
                                            <div class="flex items-center gap-4!">
                                                <div
                                                    class="w-10 h-10 rounded-lg flex items-center justify-center shrink-0 transition-colors duration-200"
                                                    [ngClass]="
                                                        dispatchCampaign.targetFilter?.mode === 'NOT_BOOKED_SINCE'
                                                            ? 'bg-primary-600 text-text-on-brand'
                                                            : 'bg-primary-50 text-primary-600'
                                                    ">
                                                    <i class="ph ph-clock-counter-clockwise text-xl"></i>
                                                </div>
                                                <div class="min-w-0 flex-1">
                                                    <h3 class="font-semibold text-text text-sm">
                                                        {{ 'DISPATCH_CAMPAIGN_TARGET_MODE_NOT_BOOKED_SINCE_TITLE' | translate }}
                                                    </h3>
                                                    <p class="text-base text-text-muted mt-0.5 leading-relaxed">
                                                        {{ 'DISPATCH_CAMPAIGN_TARGET_MODE_NOT_BOOKED_SINCE_SUBTITLE' | translate }}
                                                    </p>
                                                </div>
                                                <i
                                                    class="ph ph-caret-right text-text-muted shrink-0 text-sm transition-transform duration-200 group-hover:translate-x-0.5"></i>
                                            </div>
                                        </p-card>

                                        <p-card
                                            class="group relative text-left rounded-xl border-2 transition-all duration-200 shadow-sm cursor-pointer"
                                            [ngClass]="
                                                dispatchCampaign.targetFilter?.mode === 'ADVANCED'
                                                    ? 'border-primary-600 bg-surface'
                                                    : 'border-border bg-surface hover:border-primary-300 hover:shadow-md'
                                            "
                                            (click)="selectTargetFilterMode('ADVANCED')">
                                            <div class="flex items-center gap-4!">
                                                <div
                                                    class="w-10 h-10 rounded-lg flex items-center justify-center shrink-0 transition-colors duration-200"
                                                    [ngClass]="
                                                        dispatchCampaign.targetFilter?.mode === 'ADVANCED'
                                                            ? 'bg-primary-600 text-text-on-brand'
                                                            : 'bg-primary-50 text-primary-600'
                                                    ">
                                                    <i class="ph ph-sliders text-xl"></i>
                                                </div>
                                                <div class="min-w-0 flex-1">
                                                    <h3 class="font-semibold text-text text-sm">
                                                        {{ 'DISPATCH_CAMPAIGN_TARGET_MODE_ADVANCED_TITLE' | translate }}
                                                    </h3>
                                                    <p class="text-base text-text-muted mt-0.5 leading-relaxed">
                                                        {{ 'DISPATCH_CAMPAIGN_TARGET_MODE_ADVANCED_SUBTITLE' | translate }}
                                                    </p>
                                                </div>
                                                <i
                                                    class="ph ph-caret-right text-text-muted shrink-0 text-sm transition-transform duration-200 group-hover:translate-x-0.5"></i>
                                            </div>
                                        </p-card>
                                    </div>

                                    <div class="flex! flex-col gap-2 w-full!">
                                        @if (targetFilterModeEditorVisible() && targetFilterMode() != 'ADVANCED') {
                                            <dispatch-campaign-target-filter-mode-editor
                                                [filterMode]="targetFilterMode()"
                                                [clients]="clients()"
                                                [dispatchCampaign]="dispatchCampaign"></dispatch-campaign-target-filter-mode-editor>
                                        } @else if (targetFilterModeEditorVisible() && targetFilterMode() == 'ADVANCED') {
                                            <dispatch-campaign-target-filter-editor
                                                [dispatchCampaign]="dispatchCampaign"
                                                [filterMode]="targetFilterMode()"></dispatch-campaign-target-filter-editor>
                                        }
                                    </div>
                                </section>
                            </ng-template>
                        </p-step-panel>
                        <!--#endregion -->

                        <!-- #region HOW -->
                        <p-step-panel [value]="stepValueFromStep('HOW')">
                            <ng-template #content let-activateCallback="activateCallback">
                                <section class="flex flex-col justify-center items-center px-4 sm:px-6">
                                    <div class="text-center mb-6">
                                        <h2 class="text-text text-2xl font-semibold" translate>HOW_TITLE</h2>
                                        <p class="text-text-muted mt-1" translate>HOW_SUBTITLE</p>
                                    </div>

                                    @if (dispatchCampaign.method; as method) {
                                        <section class="grid! grid-cols-1 sm:grid-cols-2 gap-6 w-full max-w-3xl">
                                            <!-- EMAIL CARD -->
                                            <p-card
                                                class="border-2 border-transparent w-full"
                                                [ngClass]="{
                                                    'ring-2 ring-primary-500 border-primary-500!': method.primaryMethod === 'EMAIL',
                                                    'ring-2 ring-primary-500 border-primary-500! border-dotted':
                                                        method.secondaryMethod == `EMAIL`
                                                }">
                                                <div class="flex items-center gap-2! mb-4">
                                                    <div
                                                        class="w-10 h-10 rounded-lg flex items-center justify-center shrink-0 transition-colors duration-200"
                                                        [ngClass]="
                                                            method.primaryMethod === 'EMAIL' || method.secondaryMethod === 'EMAIL'
                                                                ? 'bg-primary-600 text-text-on-brand'
                                                                : 'bg-surface-sunk text-text-muted'
                                                        ">
                                                        <i class="ph ph-envelope-simple text-xl"></i>
                                                    </div>
                                                    <div class="flex-1 min-w-0">
                                                        <p class="font-semibold text-sm leading-tight" translate>EMAIL</p>
                                                        <p class="text-text-muted text-base" translate>Newsletters & rich content</p>
                                                    </div>
                                                    <p-toggleswitch
                                                        [ngModel]="primaryDispatchMethod() === 'EMAIL'"
                                                        (ngModelChange)="onEmailToggle($event)"></p-toggleswitch>
                                                </div>

                                                @if (
                                                    (method.primaryMethod === 'EMAIL' || method.secondaryMethod === 'EMAIL') &&
                                                        dispatchCampaign.emailSettings;
                                                    as emailSettings
                                                ) {
                                                    <hr class="border-border! mb-2!" />

                                                    <label translate>EMAIL_SENDER_NAME</label>
                                                    <input pInputText class="w-full" [(ngModel)]="emailSettings.senderName" />

                                                    @if (method.primaryMethod === 'EMAIL') {
                                                        <div class="flex items-center gap-2 mt-3">
                                                            <p-toggleswitch
                                                                [ngModel]="secondaryDispatchIsSms()"
                                                                (ngModelChange)="
                                                                    secondaryDispatchIsSms.set($event); methodChanged()
                                                                "></p-toggleswitch>
                                                            <span class="text-sm text-text-2" translate>SEND_SMS_AS_BACKUP</span>
                                                        </div>
                                                    }
                                                }
                                            </p-card>

                                            <!-- SMS CARD -->
                                            <p-card
                                                class="w-full border-2 border-transparent"
                                                [ngClass]="{
                                                    'ring-2 ring-primary-500 border-primary-500!':
                                                        method.primaryMethod === 'SMS' || method.secondaryMethod === 'SMS',
                                                    'ring-2 ring-primary-500 border-primary-500! border-dotted':
                                                        method.secondaryMethod == `SMS`
                                                }">
                                                <div class="flex items-center gap-2! mb-4">
                                                    <div
                                                        class="w-10 h-10 rounded-lg flex items-center justify-center shrink-0 transition-colors duration-200"
                                                        [ngClass]="
                                                            method.primaryMethod === 'SMS' || method.secondaryMethod === 'SMS'
                                                                ? 'bg-primary-600 text-text-on-brand'
                                                                : 'bg-surface-sunk text-text-muted'
                                                        ">
                                                        <i class="ph ph-chat-text text-xl"></i>
                                                    </div>
                                                    <div class="flex-1 min-w-0">
                                                        <p class="font-semibold text-sm leading-tight" translate>SMS</p>
                                                        <p class="text-text-muted text-base" translate>Short, direct messages</p>
                                                    </div>
                                                    <p-toggleswitch
                                                        [ngModel]="primaryDispatchMethod() === 'SMS' || secondaryDispatchIsSms()"
                                                        (ngModelChange)="onSmsToggle($event)"></p-toggleswitch>
                                                </div>

                                                @if (
                                                    (method.primaryMethod === 'SMS' || method.secondaryMethod === 'SMS') &&
                                                        dispatchCampaign.smsSettings;
                                                    as smsSettings
                                                ) {
                                                    <hr class="border-border! mb-2!" />

                                                    <label translate>SMS_SENDER_NAME</label>
                                                    <input
                                                        pInputText
                                                        class="w-full"
                                                        [(ngModel)]="smsSettings.senderName"
                                                        (keyup)="smsSenderNameChanged()" />
                                                    @if (method.primaryMethod === 'SMS') {
                                                        <div class="flex items-center gap-2 mt-3">
                                                            <p-toggleswitch
                                                                [ngModel]="secondaryDispatchIsEmail()"
                                                                (ngModelChange)="
                                                                    secondaryDispatchIsEmail.set($event); methodChanged()
                                                                "></p-toggleswitch>
                                                            <span class="text-sm text-text-2" translate>SEND_EMAIL_AS_BACKUP</span>
                                                        </div>
                                                    }
                                                }
                                            </p-card>
                                        </section>
                                    }
                                </section>
                            </ng-template>
                        </p-step-panel>
                        <!-- #endregion -->

                        <!-- #region WHAT -->
                        <p-step-panel [value]="stepValueFromStep('WHAT')">
                            <ng-template #content let-activateCallback="activateCallback">
                                <section (animate.enter)="animateStepIn($event)">
                                    <div class="text-center mb-6">
                                        <h2 class="text-text text-2xl font-semibold" translate>WHAT_TITLE</h2>
                                        <p class="text-text-muted mt-1" translate>WHAT_SUBTITLE</p>
                                    </div>
                                </section>
                                <section class="w-full max-w-6xl px-2 sm:px-4" (animate.enter)="animateStepIn($event)">
                                    <p-tabs [value]="selectedWhatTab()">
                                        <p-tablist>
                                            <p-tab
                                                value="email"
                                                [disabled]="
                                                    dispatchCampaign.method?.primaryMethod != 'EMAIL' &&
                                                    dispatchCampaign.method?.secondaryMethod != 'EMAIL'
                                                ">
                                                <i class="piph-envelope"></i>
                                                &nbsp;
                                                <span>{{ 'EMAIL' | translate }}</span>
                                            </p-tab>
                                            <p-tab
                                                value="sms"
                                                [disabled]="
                                                    dispatchCampaign.method?.primaryMethod != 'SMS' &&
                                                    dispatchCampaign.method?.secondaryMethod != 'SMS'
                                                ">
                                                <i class="ph ph-comment"></i>
                                                &nbsp;
                                                <span>{{ 'SMS' | translate }}</span>
                                            </p-tab>
                                        </p-tablist>
                                        <p-tabpanels>
                                            <!-- EMAIL TAB -->
                                            <p-tabpanel value="email">
                                                @if (dispatchCampaign.emailSettings; as emailSettings) {
                                                    <section
                                                        class="grid! grid-cols-1! xl:grid-cols-2! gap-8!"
                                                        (animate.enter)="animateStepIn($event)">
                                                        <section class="flex! flex-col! gap-8!">
                                                            <p-card class="border border-border!">
                                                                <section class="flex! flex-col! gap-2">
                                                                    <div>
                                                                        <p class="text-base font-medium">
                                                                            {{ 'EMAIL_SUBJECT' | translate }}
                                                                        </p>
                                                                        <p class="text-sm">{{ 'EMAIL_SUBJECT_DESC' | translate }}</p>
                                                                    </div>
                                                                    <input
                                                                        type="text"
                                                                        pInputText
                                                                        [(ngModel)]="emailSettings.subject"
                                                                        fluid
                                                                        placeholder="e.g. Dont miss our summer deals!" />
                                                                </section>
                                                            </p-card>
                                                            <p-card class="border border-border!">
                                                                <section class="flex! flex-col! gap-2">
                                                                    <div
                                                                        class="flex! flex-wrap! gap-4! w-full! justify-between! items-start!">
                                                                        <div class="min-w-0">
                                                                            <p class="text-base font-medium">
                                                                                {{ 'EMAIL_TEMPLATE' | translate }}
                                                                            </p>
                                                                            <p class="text-sm">{{ 'EMAIL_TEMPLATE_DESC' | translate }}</p>
                                                                        </div>

                                                                        <div class="flex! gap-2! items-center shrink-0">
                                                                            <button pButton (click)="openEmailEditor()">
                                                                                {{ `EDIT_TEMPLATE` | translate }}
                                                                            </button>
                                                                            <button pButton (click)="openTemplateSelector()">
                                                                                {{ `START_WITH_TEMPLATE` | translate }}
                                                                            </button>
                                                                        </div>
                                                                    </div>
                                                                    <div
                                                                        [ngClass]="{
                                                                            'p-8': !emailThumbnailSrc,
                                                                            'p-0': emailThumbnailSrc
                                                                        }"
                                                                        class="mt-4 rounded-lg border border-dashed border-border! bg-surface-sunk! flex flex-col items-center justify-center text-center min-h-50">
                                                                        @if (emailThumbnailSrc; as thumbnailSrc) {
                                                                            <img class="thumbnail" [src]="thumbnailSrc" />
                                                                        } @else {
                                                                            <div
                                                                                class="flex h-12 w-12 items-center justify-center rounded-full bg-brand-tint text-brand text-2xl mb-3">
                                                                                <i class="ph ph-envelope-simple"></i>
                                                                            </div>
                                                                            <p class="text-sm font-medium text-text">
                                                                                {{ 'TEMPLATE_MISSING' | translate }}
                                                                            </p>
                                                                            <p class="text-base text-text-muted mt-1">
                                                                                {{ 'TEMPLATE_MISSING_SUB' | translate }}
                                                                            </p>
                                                                        }
                                                                    </div>
                                                                </section>
                                                            </p-card>
                                                            <p-card>
                                                                <section class="flex! flex-col! gap-2">
                                                                    <div>
                                                                        <p class="text-base font-medium">
                                                                            {{ 'EMAIL_TEST_DISPATCH' | translate }}
                                                                        </p>
                                                                        <p class="text-sm">{{ 'TEST_EMAIL_DESC' | translate }}</p>
                                                                    </div>
                                                                    <p-autocomplete
                                                                        [fluid]="true"
                                                                        [ngModel]="tempTestDispatchEmailAddresses()"
                                                                        (ngModelChange)="tempTestDispatchEmailAddresses.set($event)"
                                                                        multiple
                                                                        [typeahead]="false"
                                                                        [addOnBlur]="true"
                                                                        [addOnTab]="true"
                                                                        separator=","
                                                                        placeholder="{{ 'INPUT_EMAIL_ADDRESSES' | translate }}" />
                                                                    <button
                                                                        pButton
                                                                        (click)="sendTestDispatchEmails()"
                                                                        [disabled]="!tempTestDispatchEmailAddresses().length"
                                                                        [loading]="emailLoading()"
                                                                        [fluid]="true">
                                                                        <i class="ph ph-send"></i>
                                                                        <span>{{ `SEND_TEST` | translate }}</span>
                                                                    </button>
                                                                </section>
                                                            </p-card>
                                                        </section>

                                                        <!-- EMAIL PREVIEW -->
                                                        <section class="flex! flex-col! gap-6" (animate.enter)="animateStepIn($event)">
                                                            <p class="text-center text-text-muted">{{ 'EMAIL_PREVIEW' | translate }}</p>
                                                            <section
                                                                class="rounded-2xl border border-border! bg-surface shadow-sm overflow-hidden">
                                                                <div class="px-4 py-3 border-t border-border!">
                                                                    <div class="flex! items-center justify-between">
                                                                        <div class="h-3 w-24 rounded bg-surface-sunk!"></div>
                                                                        <div class="h-2 w-10 rounded bg-surface-sunk!"></div>
                                                                    </div>
                                                                    <div class="h-3 w-40 rounded bg-surface-sunk! mt-1.5"></div>
                                                                    <div class="h-2 w-full rounded bg-surface-sunk! mt-1.5"></div>
                                                                </div>
                                                                <div class="px-4 py-3 bg-brand/5 border-l-2 border-brand">
                                                                    <div class="flex! items-center justify-between">
                                                                        <span class="text-sm font-semibold">
                                                                            {{ emailSettings.senderName }}
                                                                        </span>
                                                                        <span class="text-sm font-semibold text-text-muted">
                                                                            {{ 'NOW' | translate }}
                                                                        </span>
                                                                    </div>
                                                                    <div class="text-sm font-medium text-text mt-0.5 truncate!">
                                                                        {{
                                                                            emailSettings.subject?.length
                                                                                ? emailSettings.subject
                                                                                : ('EMAIL_SUBJECT_PLACEHOLDER' | translate)
                                                                        }}
                                                                    </div>
                                                                    <div class="text-sm font-medium text-text mt-0.5 truncate">
                                                                        {{ 'EMAIL_CONTENT_PLACEHOLDER' | translate }}
                                                                    </div>
                                                                </div>
                                                                <div class="px-4 py-3 border-t border-border!">
                                                                    <div class="flex! items-center justify-between">
                                                                        <div class="h-3 w-24 rounded bg-surface-sunk!"></div>
                                                                        <div class="h-2 w-10 rounded bg-surface-sunk!"></div>
                                                                    </div>
                                                                    <div class="h-3 w-40 rounded bg-surface-sunk! mt-1.5"></div>
                                                                    <div class="h-2 w-full rounded bg-surface-sunk! mt-1.5"></div>
                                                                </div>
                                                                <div class="px-4 py-3 border-t border-border!">
                                                                    <div class="flex! items-center justify-between">
                                                                        <div class="h-3 w-24 rounded bg-surface-sunk!"></div>
                                                                        <div class="h-2 w-10 rounded bg-surface-sunk!"></div>
                                                                    </div>
                                                                    <div class="h-3 w-40 rounded bg-surface-sunk! mt-1.5"></div>
                                                                    <div class="h-2 w-full rounded bg-surface-sunk! mt-1.5"></div>
                                                                </div>
                                                            </section>
                                                        </section>
                                                    </section>
                                                }
                                            </p-tabpanel>

                                            <!-- SMS TAB -->
                                            <p-tabpanel value="sms">
                                                @if (dispatchCampaign.smsSettings; as smsSettings) {
                                                    <section
                                                        class="grid! grid-cols-1! xl:grid-cols-2! gap-8!"
                                                        (animate.enter)="animateStepIn($event)">
                                                        <section class="flex! flex-col! gap-8!" (animate.enter)="animateStepIn($event)">
                                                            <p-card class="border border-border!">
                                                                <section class="flex! flex-col! gap-2">
                                                                    <div
                                                                        class="flex! flex-wrap! gap-4! w-full! justify-between! items-start!">
                                                                        <div class="min-w-0">
                                                                            <p class="text-base font-medium">
                                                                                {{ 'SMS_MESSAGE' | translate }}
                                                                            </p>
                                                                            <p class="text-sm">{{ 'SMS_MESSAGE_DESC' | translate }}</p>
                                                                        </div>

                                                                        <div class="flex! gap-2! items-center shrink-0">
                                                                            <p class="text-base text-text-muted!">
                                                                                {{ smsSettings.content?.length ?? 0 }}/160
                                                                            </p>
                                                                            <p
                                                                                class="text-base text-text-muted! p-1 px-2 bg-surface-sunk! rounded">
                                                                                {{ getNumberOfSmsSegments() }}
                                                                                {{ 'SMS_SEGMENTS' | translate }}
                                                                            </p>
                                                                        </div>
                                                                    </div>
                                                                    <div
                                                                        class="mt-4 rounded-lg border border-dashed border-border! bg-surface-sunk! min-h-50">
                                                                        <textarea
                                                                            class="h-full!"
                                                                            cols="50"
                                                                            pTextarea
                                                                            fluid
                                                                            [(ngModel)]="smsSettings.content"></textarea>
                                                                    </div>
                                                                </section>
                                                            </p-card>
                                                            <p-card>
                                                                <section class="flex! flex-col! gap-2">
                                                                    <div>
                                                                        <p class="text-base font-medium">
                                                                            {{ 'AVAILABLE_PLACEHOLDERS' | translate }}
                                                                        </p>
                                                                        <p class="text-sm">
                                                                            Placeholders are replaced with a value when sent.
                                                                        </p>
                                                                    </div>
                                                                    <div class="flex! gap-2 flex-wrap!">
                                                                        <button
                                                                            pButton
                                                                            severity="secondary"
                                                                            (click)="utils.copyToClipboard('{FIRST_NAME}')">
                                                                            <i class="ph ph-copy"></i>
                                                                            <span>{{ '{FIRST_NAME}' }}</span>
                                                                        </button>
                                                                        <button
                                                                            pButton
                                                                            severity="secondary"
                                                                            (click)="utils.copyToClipboard('{LAST_NAME}')">
                                                                            <i class="ph ph-copy"></i>
                                                                            <span>{{ '{LAST_NAME}' }}</span>
                                                                        </button>
                                                                        <button
                                                                            pButton
                                                                            severity="secondary"
                                                                            (click)="utils.copyToClipboard('{UNSUBSCRIBE_LINK}')">
                                                                            <i class="ph ph-copy"></i>
                                                                            <span>{{ '{UNSUBSCRIBE_LINK}' }}</span>
                                                                        </button>
                                                                    </div>
                                                                </section>
                                                            </p-card>

                                                            <p-card>
                                                                <section class="flex! flex-col! gap-2!">
                                                                    <div>
                                                                        <p class="text-base font-medium">
                                                                            {{ 'URL_SHORTNER' | translate }}
                                                                        </p>
                                                                        <p class="text-sm">{{ 'SMS_SHORT_URL_INFO' | translate }}</p>
                                                                    </div>
                                                                    <div class="flex! flex-col! gap-px!">
                                                                        <section class="w-full! flex! gap-2 flex-col min-h-32">
                                                                            @if (
                                                                                dispatchCampaign.metadata?.associatedShortUrls;
                                                                                as shortUrls
                                                                            ) {
                                                                                @for (shortLink of shortUrls; track shortLink) {
                                                                                    <button
                                                                                        pButton
                                                                                        severity="secondary"
                                                                                        [fluid]="true"
                                                                                        (click)="utils.copyToClipboard(shortLink.shortUrl)">
                                                                                        <i class="ph ph-copy"></i>
                                                                                        <span>{{ shortLink }}</span>
                                                                                    </button>
                                                                                }
                                                                            }
                                                                        </section>
                                                                        <p-floatlabel variant="on" class="w-full!">
                                                                            <input
                                                                                pInputText
                                                                                [fluid]="true"
                                                                                class="w-full!"
                                                                                placeHolder="https://www.google.com"
                                                                                [ngModel]="tempLongUrl()"
                                                                                (ngModelChange)="tempLongUrl.set($event)" />
                                                                            <label>{{ 'LONG_URL' | translate }}</label>
                                                                        </p-floatlabel>
                                                                        <button
                                                                            pButton
                                                                            severity="secondary"
                                                                            [text]="true"
                                                                            [fluid]="true"
                                                                            [disabled]="!validateTempLongUrl()"
                                                                            (click)="shortenUrl()">
                                                                            {{ 'CONVERT' | translate }}
                                                                        </button>
                                                                    </div>
                                                                </section>
                                                            </p-card>
                                                        </section>

                                                        <!-- SMS PREVIEW -->
                                                        <section class="flex! flex-col gap-9! w-full">
                                                            <div>
                                                                <p class="text-center text-base text-text-muted pb-2!">
                                                                    {{ 'SMS_PREVIEW' | translate }}
                                                                </p>
                                                                <section
                                                                    class="rounded-2xl border border-border bg-surface overflow-hidden shadow-sm">
                                                                    <div
                                                                        class="flex! items-center gap-3 px-4 py-3 border-b border-border bg-surface-card">
                                                                        <div
                                                                            class="w-9 h-9 rounded-full bg-info-tint flex items-center justify-center shrink-0">
                                                                            <span class="text-base font-semibold text-info">
                                                                                {{ smsSettings.senderName | slice: 0 : 2 | uppercase }}
                                                                            </span>
                                                                        </div>
                                                                        <div class="flex! flex-col">
                                                                            <span class="text-sm font-semibold text-text leading-tight">
                                                                                {{ smsSettings.senderName }}
                                                                            </span>
                                                                            <span class="text-base text-sm text-text-muted">SMS</span>
                                                                        </div>
                                                                    </div>

                                                                    <div class="flex! flex-col gap-3 px-4 py-4 bg-surface">
                                                                        <div class="flex! justify-end">
                                                                            <div
                                                                                class="bg-surface-sunk rounded-2xl rounded-br-sm px-4 py-2.5 max-w-[70%] flex flex-col gap-1.5">
                                                                                <div class="h-2 w-40 rounded-full bg-border-strong"></div>
                                                                                <div class="h-2 w-32 rounded-full bg-border-strong"></div>
                                                                                <div class="h-2 w-16 rounded-full bg-border-strong"></div>
                                                                            </div>
                                                                        </div>

                                                                        <div class="flex! justify-start">
                                                                            <div
                                                                                class="bg-surface-sunk rounded-2xl rounded-bl-sm px-4 py-2.5 max-w-[70%] flex flex-col gap-1.5">
                                                                                <div class="h-2 w-44 rounded-full bg-border-strong"></div>
                                                                                <div class="h-2 w-28 rounded-full bg-border-strong"></div>
                                                                            </div>
                                                                        </div>

                                                                        <div class="flex! justify-end">
                                                                            <div class="flex! flex-col items-end gap-1 max-w-[75%]">
                                                                                <div
                                                                                    class="bg-primary-500 rounded-2xl rounded-br-sm px-4 py-2.5">
                                                                                    <p
                                                                                        class="text-text-on-brand text-sm leading-relaxed m-0 max-w-xs!">
                                                                                        {{
                                                                                            smsSettings.content ||
                                                                                                'Your SMS preview will show here'
                                                                                        }}
                                                                                    </p>
                                                                                </div>
                                                                                <div class="flex items-center gap-1">
                                                                                    <span class="text-2xs text-text-muted">Delivered</span>
                                                                                    <svg
                                                                                        class="w-3.5 h-2.5 text-brand"
                                                                                        viewBox="0 0 12 8"
                                                                                        fill="none">
                                                                                        <path
                                                                                            d="M1 4L3.5 6.5L7 2"
                                                                                            stroke="currentColor"
                                                                                            stroke-width="1.5"
                                                                                            stroke-linecap="round"
                                                                                            stroke-linejoin="round" />
                                                                                        <path
                                                                                            d="M5 4L7.5 6.5L11 2"
                                                                                            stroke="currentColor"
                                                                                            stroke-width="1.5"
                                                                                            stroke-linecap="round"
                                                                                            stroke-linejoin="round" />
                                                                                    </svg>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </section>
                                                            </div>
                                                            <p-card>
                                                                <section class="flex! flex-col! gap-2">
                                                                    <div>
                                                                        <p class="text-base text-text font-medium">
                                                                            {{ 'SMS_TEST_DISPATCH' | translate }}
                                                                        </p>
                                                                        <p class="text-sm text-text">{{ 'TEST_SMS_DESC' | translate }}</p>
                                                                    </div>
                                                                    <p-autocomplete
                                                                        [fluid]="true"
                                                                        [ngModel]="tempTestDispatchSmsNumbers()"
                                                                        (ngModelChange)="tempTestDispatchSmsNumbers.set($event)"
                                                                        multiple
                                                                        [typeahead]="false"
                                                                        [addOnBlur]="true"
                                                                        [addOnTab]="true"
                                                                        separator=","
                                                                        placeholder="{{ 'INPUT_PHONE_NUMBERS' | translate }}" />

                                                                    <button
                                                                        pButton
                                                                        (click)="sendTestDispatchSms()"
                                                                        [disabled]="!tempTestDispatchSmsNumbers().length"
                                                                        [loading]="smsLoading()"
                                                                        [fluid]="true">
                                                                        <i class="ph ph-send"></i>
                                                                        <span>{{ `SEND_TEST` | translate }}</span>
                                                                    </button>
                                                                </section>
                                                            </p-card>
                                                        </section>
                                                    </section>
                                                }
                                            </p-tabpanel>
                                        </p-tabpanels>
                                    </p-tabs>
                                </section>
                            </ng-template>
                            <p-drawer
                                [visible]="emailEditorVisible()"
                                (visibleChange)="emailEditorVisible.set($event)"
                                [closable]="false"
                                [position]="'bottom'"
                                styleClass="h-[95vh]!"
                                appendTo="body">
                                <ng-template #header>
                                    <div class="w-full">
                                        <div class="flex justify-between">
                                            <div class="col">
                                                @if (!mailluneEnabled) {
                                                    <button
                                                        pButton
                                                        severity="secondary"
                                                        [text]="true"
                                                        (click)="showAvailablePlaceholders($event)">
                                                        {{ 'PLACEHOLDERS' | translate }}
                                                    </button>
                                                }
                                                @if (mailluneEnabled) {
                                                    <button pButton severity="secondary" (click)="openTemplates()">
                                                        {{ 'TEMPLATES' | translate }}
                                                    </button>
                                                    <button pButton severity="secondary" (click)="openSaveAsTemplateDialog()">
                                                        {{ 'SAVE_AS_TEMPLATE' | translate }}
                                                    </button>
                                                }
                                                <p-popover #placeholders>
                                                    <div class="flex! flex-col items-start justify-start! gap-4">
                                                        <div>
                                                            <span class="font-medium block mb-2">
                                                                {{ 'AVAILABLE_PLACEHOLDERS' | translate }}
                                                            </span>
                                                            <ul class="list-none p-0 m-0 flex! flex-col">
                                                                @for (placeholder of availableEmailPlaceholders; track placeholder) {
                                                                    <li
                                                                        class="flex items-center gap-2 px-2 py-3 hover:bg-surface-sunk cursor-pointer rounded"
                                                                        (click)="copyEmailPlaceholder(placeholder.placeHolder, $event)">
                                                                        <div class="w-full! flex! flex-col! justify-start! items-start!">
                                                                            <div
                                                                                class="font-medium flex! justify-between items-center w-full!">
                                                                                <span>{{ placeholder.label }}</span>
                                                                                <i class="ph ph-copy"></i>
                                                                            </div>
                                                                            <div class="text-base text-text-muted">
                                                                                {{ placeholder.description }}
                                                                            </div>
                                                                        </div>
                                                                    </li>
                                                                }
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </p-popover>
                                            </div>
                                            <div class="col align-right">
                                                <button
                                                    pButton
                                                    severity="danger"
                                                    [disabled]="savingEmailTemplate()"
                                                    (click)="closeEmailEditor()">
                                                    {{ 'CANCEL' | translate }}
                                                </button>
                                                &nbsp;
                                                <button
                                                    pButton
                                                    severity="success"
                                                    [loading]="savingEmailTemplate()"
                                                    [disabled]="savingEmailTemplate()"
                                                    (click)="saveEmailTemplate()">
                                                    {{ 'SAVE' | translate }}
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </ng-template>
                                <ng-template #content>
                                    @if (emailEditorVisible() && mailluneConfig; as ml) {
                                        <maillune-template-editor
                                            #mailluneTemplateEditor
                                            [config]="ml"
                                            (templateSaved)="mailluneTemplateSaved($event)"></maillune-template-editor>
                                    } @else if (emailEditorVisible()) {
                                        <beefree-template-editor
                                            #beefreeTemplateEditor
                                            [config]="beefreeConfig"
                                            (templateSaved)="beefreeTemplateSaved($event)"></beefree-template-editor>
                                    }
                                </ng-template>
                            </p-drawer>

                            <p-dialog
                                [(visible)]="saveAsTemplateDialogVisible"
                                [modal]="true"
                                [closable]="true"
                                [draggable]="false"
                                appendTo="body"
                                [header]="'SAVE_AS_TEMPLATE' | translate"
                                styleClass="w-full max-w-lg!">
                                <div class="flex! w-full flex-col gap-6 py-2">
                                    <p-floatlabel variant="on">
                                        <input
                                            type="text"
                                            fluid
                                            pInputText
                                            class="w-full"
                                            [ngModel]="saveAsTemplateName()"
                                            (ngModelChange)="saveAsTemplateName.set($event)"
                                            [autofocus]="true" />
                                        <label>{{ 'TEMPLATE_NAME' | translate }}</label>
                                    </p-floatlabel>
                                </div>

                                <ng-template #footer>
                                    <div class="flex justify-end gap-2">
                                        <button pButton severity="secondary" (click)="cancelSaveAsTemplate()">
                                            {{ 'CANCEL' | translate }}
                                        </button>
                                        <button
                                            pButton
                                            [loading]="savingAsTemplate()"
                                            [disabled]="!saveAsTemplateName().trim()"
                                            (click)="confirmSaveAsTemplate()">
                                            {{ 'SAVE' | translate }}
                                        </button>
                                    </div>
                                </ng-template>
                            </p-dialog>
                        </p-step-panel>
                        <!-- #endregion -->

                        <!-- #region WHEN -->
                        <p-step-panel [value]="stepValueFromStep('WHEN')">
                            <ng-template #content let-activateCallback="activateCallback">
                                @if (selectedStep() == 'WHEN') {
                                    <section (animate.enter)="animateStepIn($event)">
                                        <div class="text-center mb-6">
                                            <h2 class="text-text text-2xl font-semibold" translate>WHEN_TITLE</h2>
                                            <p class="text-text-muted mt-1" translate>WHEN_SUBTITLE</p>
                                        </div>
                                    </section>
                                    <section class="flex justify-center items-start p-2 sm:p-4">
                                        <section class="grid! grid-cols-1 gap-6 w-full max-w-2xl">
                                            <p-card class="flex flex-col gap-4!">
                                                <div class="flex! justify-start items-start gap-2 mb-4">
                                                    <div
                                                        class="w-10 h-10 rounded-lg bg-primary-600 text-text-on-brand! text-2xl! flex items-center justify-center shrink-0 transition-colors duration-200">
                                                        <i class="ph ph-timer"></i>
                                                    </div>
                                                    <div>
                                                        <p class="font-bold! text-base" translate>DISPATCH_DATE_TEXT</p>
                                                        <p class="text-sm" translate>DISPATCH_DATE_SUBTEXT</p>
                                                    </div>
                                                </div>
                                                @if (dispatchCampaign.timing; as timing) {
                                                    <div class="flex flex-col sm:flex-row gap-4">
                                                        <div class="flex! flex-col justify-start! items-start! flex-1">
                                                            <label for="" translate>DATE</label>
                                                            <p-datepicker
                                                                [showIcon]="true"
                                                                class="w-full"
                                                                [iconDisplay]="'input'"
                                                                [fluid]="true"
                                                                [(ngModel)]="timing.dispatchDate"></p-datepicker>
                                                        </div>
                                                        <div class="flex! flex-col justify-start! items-start! flex-1">
                                                            <label for="" translate>TIME</label>
                                                            <p-datepicker
                                                                [showIcon]="true"
                                                                class="w-full"
                                                                [timeOnly]="true"
                                                                [fluid]="true"
                                                                [iconDisplay]="'input'"
                                                                [(ngModel)]="timing.dispatchDate">
                                                                <ng-template #inputicon let-clickCallBack="clickCallBack">
                                                                    <i class="ph ph-clock" (click)="clickCallBack($event)"></i>
                                                                </ng-template>
                                                            </p-datepicker>
                                                        </div>
                                                    </div>
                                                }
                                                <div class="flex! bg-brand-tint rounded p-2 mt-2">
                                                    <div class="flex! justify-center items-center text-brand">
                                                        <i class="ph ph-info"></i>
                                                    </div>
                                                    <div class="text-start">
                                                        <p class="text-base text-brand">{{ 'DISPATCH_DATE_INFO' | translate }}</p>
                                                    </div>
                                                </div>
                                            </p-card>

                                            <p-card
                                                class="border relative overflow-hidden transition-all"
                                                [ngClass]="{
                                                    'border-danger': !dispatchCampaign.isArmed,
                                                    'border-success': dispatchCampaign.isArmed
                                                }">
                                                @if (dispatchCampaign.status == 'PROCESSING_TARGET_FILTER') {
                                                    <section
                                                        (animate.enter)="animateStepIn($event)"
                                                        class="absolute w-full h-full top-0 z-10 left-0 backdrop-blur-xs p-4 bg-gray-500/10 flex! justify-center items-center">
                                                        <div
                                                            class="bg-warn/90 shadow-lg text-white p-2 rounded-md flex! flex-col"
                                                            translate>
                                                            PROCESSING_TARGET_FILTER_INFO
                                                        </div>
                                                    </section>
                                                }
                                                <section class="flex! flex-col gap-2">
                                                    <h2 class="font-semibold text-sm mb-0" translate>
                                                        {{ dispatchCampaign.isArmed ? 'ARMED_CAMPAIGN' : 'WARNING' }}
                                                    </h2>
                                                    <div class="flex! flex-col gap-2">
                                                        <p class="text-sm">
                                                            @if (!dispatchCampaign.isArmed) {
                                                                {{ 'SCHEDULE_WARNING_DESC' | translate }}
                                                            }
                                                        </p>

                                                        @if (!dispatchCampaign.isArmed) {
                                                            <button
                                                                pButton
                                                                severity="success"
                                                                [disabled]="dispatchCampaign.status == `PROCESSING_TARGET_FILTER`"
                                                                (click)="confirmDispatch($event)">
                                                                {{ `SCHEDULE_CAMPAIGN` | translate }}
                                                            </button>
                                                        }
                                                    </div>
                                                </section>
                                            </p-card>
                                        </section>
                                    </section>
                                }
                            </ng-template>
                        </p-step-panel>
                        <!-- #endregion -->
                    </p-step-panels>
                </section>
            </p-stepper>
        }

        @if (dispatchCampaign.status == 'PROCESSING_DISPATCH') {
            <div class="dispatch-campaign-content">
                <div class="align-center">
                    <loading-icon [size]="'large'"></loading-icon>
                    <h2 translate>PROCESSING_DISPATCH_CAMPAIGN</h2>
                    <a [routerLink]="['/organizations', auth.organizationId(), 'crm', 'campaigns']">
                        <button pButton severity="secondary" [text]="true">
                            {{ 'BACK_TO_CAMPAIGN_LIST' | translate }}
                        </button>
                    </a>
                </div>
            </div>
        }

        <!-- #region RESULTS -->
        @if (dispatchCampaign.status == 'DISPATCHED') {
            <div>
                <section class="flex! flex-col! items-center justify-center! gap-4! min-h-dvh">
                    <button pButton class="absolute! top-20 left-6" [outlined]="true" [routerLink]="['/organizations', auth.organizationId(), 'crm', 'campaigns']">
                        <i class="ph ph-arrow-left"></i>
                        <span>{{ `BACK_TO_CAMPAIGN_LIST` | translate }}</span>
                    </button>
                    <section class="flex! flex-col! gap-8! max-w-4xl w-full!" (animate.enter)="animateStepIn($event)">
                        <div class="relative flex items-center justify-center mb-8">
                            <div class="absolute w-20 h-20 bg-success/20 rounded-full animate-ping"></div>
                            <div
                                class="relative w-16 h-16 bg-success rounded-full flex items-center justify-center shadow-lg shadow-success/40">
                                <i class="ph ph-check text-white text-2xl font-bold"></i>
                            </div>
                        </div>

                        <div class="text-center!">
                            <p>{{ dispatchCampaign.name }}</p>
                            <h2 class="text-2xl font-bold!" translate>CAMPAIGN_IS_DISPATCHED</h2>
                        </div>

                        @if (dispatchCampaignResults?.email; as emailResults) {
                            <p-card class="w-full">
                                <section class="text-start">
                                    <h2 class="text-xl font-semibold" translate>EMAIL</h2>
                                </section>

                                <section class="grid! grid-cols-3 flex-wrap gap-4!" (animate.enter)="animateStepIn($event)">
                                    @for (statistic of emailResults | keyvalue; track statistic) {
                                        <div
                                            [ngClass]="{ 'col-span-2': $index == 4 }"
                                            class="p-4 border shadow-sm! rounded-xl border-border! flex! flex-col justify-center items-center gap-px!">
                                            <p class="font-semibold text-xl">{{ emailKeyToTranslation(statistic.key) | translate }}</p>
                                            <p class="text-sm">{{ statistic.value }}</p>
                                        </div>
                                    }
                                </section>
                            </p-card>
                        }

                        @if (dispatchCampaignResults?.sms; as smsResults) {
                            <p-card class="w-full">
                                <section class="text-start">
                                    <h2 class="text-xl font-semibold" translate>SMS</h2>
                                </section>

                                <section class="grid! grid-cols-3 gap-4!" (animate.enter)="animateStepIn($event)">
                                    @for (statistic of smsResults | keyvalue; track statistic) {
                                        <div
                                            class="p-4 border shadow-sm! rounded-xl border-border! flex! flex-col justify-center items-center gap-px!">
                                            <p class="font-semibold text-xl">{{ smsKeyToTranslation(statistic.key) | translate }}</p>
                                            <p class="text-sm">{{ statistic.value }}</p>
                                        </div>
                                    }
                                </section>
                            </p-card>
                        }
                    </section>
                </section>
            </div>
        }
        <!-- #endregion -->

    </div>
}
